import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import ContentSection from '../components/sections/ContentSection';
import CTASection from '../components/sections/CTASection';
import PricingPreview from '../components/sections/PricingPreview';
import { useTranslation } from '../hooks/useTranslation';
import { useSEO } from '../hooks/useSEO';

const ResidentialProxiesPage = () => {
  const { t } = useTranslation();
  useSEO('residential-proxies'); 

  // Features List
  const features = t('proxies.residential.features.list', { returnObjects: true });
  const featuresList = Array.isArray(features) ? features : [];
  const featuresWithIcons = featuresList.map((f, i) => ({
    ...f,
    icon: ['Lock', 'Zap', 'Globe', 'Smartphone', 'Shield'][i % 5]
  }));

  // Advantages List
  const advantages = t('proxies.residential.advantages.list', { returnObjects: true });
  const advantagesList = Array.isArray(advantages) ? advantages : [];
  const advantagesWithIcons = advantagesList.map((f, i) => ({
    ...f,
    icon: ['Zap', 'Headphones'][i % 2]
  }));

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        {/* Hero */}
        <HeroSection 
          title1={t('proxies.residential.hero.title1')}
          title2={t('proxies.residential.hero.title2')}
          subtitle={t('proxies.residential.hero.subtitle')}
          className="pb-12"
          priceBadge="only $0.9 / GB"
        />

        <PricingPreview />

        {/* How IP9 Stands Out */}
        <ContentSection 
          title={t('proxies.residential.standOut.title')}
          content={t('proxies.residential.standOut.content', { returnObjects: true })}
          className="bg-slate-900"
        />

        {/* Key Features */}
        <FeaturesSection 
          title={t('proxies.residential.features.title')}
          subtitle={t('proxies.residential.features.subtitle')}
          features={featuresWithIcons}
        />

        {/* Why Choose IP9 */}
        <ContentSection 
          title={t('proxies.residential.whyChoose.title')}
          content={t('proxies.residential.whyChoose.content', { returnObjects: true })}
          className="bg-slate-950"
        />

        {/* Additional Advantages */}
        <FeaturesSection 
          title={t('proxies.residential.advantages.title')}
          subtitle=""
          features={advantagesWithIcons}
          columns={2}
        />

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ResidentialProxiesPage;
